import Vue from 'vue';
import App from './App.vue';

import { store } from './store/store';
import { config } from './config';

import router from "./router";
import indexMixin from "./mixins/index";
import filters from './filters/filters';
import clickOutside from './directives/clickOutside';
import { ResponsiveDirective } from "vue-responsive-components";

import Buefy from 'buefy';
import '@mdi/font/css/materialdesignicons.css';
import configPlugin from '@/config';
import ICS from 'vue-ics';
import VuePaycard from 'vue-paycard';
import * as VueGoogleMaps from "vue2-google-maps";
//import helpers  from './plugins/helpers';
import plugins from  './plugins/index.js';
import VueMask from 'v-mask'


Vue.use(VueMask);
Vue.use(Buefy);
Vue.use(configPlugin);
Vue.use(ICS);
Vue.use(VuePaycard);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAUznqoyCkPpLnwC8Z_pOfI1gKC6ZI74fs",
    libraries: "places, marker, geometry" // necessary for places input
  }
});

Vue.config.productionTip = false;
Vue.config.performance = true;

// use imported mixins (Vue.mixin() for each imported file)
Vue.mixin(indexMixin);

// use global plugins
Vue.use(plugins);

// use imported filters (Vue.filter() for each imported file)
// in this case (filters.js) we will loop through all the methods defined in that file
Object.keys(filters).forEach(
    key => {
      Vue.filter(key, filters[key]);
    }
);

import VAnimateCss from 'v-animate-css';
Vue.use(VAnimateCss);

import moment from "moment";
Vue.prototype.$moment = moment;

// use imported directives
Vue.directive('clickOutside', clickOutside);
Vue.directive('responsive', ResponsiveDirective);

export const eventBus = new Vue(); // creating an event bus.

const app = new Vue({
  router,
  store,
  config,
  render: h => h(App),
}).$mount('#app');

// Add `store` to the window object only when testing with Cypress
if (window.Cypress) {
  window.app = app;
}